
  import { mapState } from 'vuex'
  import moment from 'moment'

  export default {
    data() {
      return {
        selected: [],
        showFilter: false,
        showLocationPopup: false,
        showAll: [],
        observedCategories: new Set(),
        showItemNotFound: false
      }
    },
    mounted() {
      // console.log('MenuCategories mounted with state:', {
      //   deeplinkProductNotFoundAtLocation: this.deeplinkProductNotFoundAtLocation,
      //   deeplinkProduct: this.deeplinkProduct,
      //   route: this.$route.path
      // })

      if (this.deeplinkProductQuery && this.deeplinkProductNotFoundAtLocation) {
        // Attempt to lookup product by query
        const product = this.findProductByQuery(this.deeplinkProductQuery)
        if (product) {
          this.$store.commit('setDeeplinkProduct', product)
          this.$store.commit('setDeeplinkProductQuery', null)
          this.$store.commit('setDeeplinkProductNotFoundAtLocation', false)
          if (this.menu) {
            this.$router.push(`/order/product?id=${product.sku}`)
            return
          } else {
            this.$router.push(`/menu/product?id=${product.sku}`)
            return
          }
        } else {
          this.showItemNotFound = true
        }
      }
      
      // Redirect to order page if order is started
      if (
        this.order &&
        this.$route.name !== 'order' &&
        this.$route.name !== 'menu-mid' // we need the mid to set the location, handoffs and referral
      ) {
        this.$router.push(this.$route.fullPath.replace('menu','order'))
      }

      // Show popup if no location is selected
      if (!this.menu && !this.deeplinkProductNotFoundAtLocation) {
        this.showLocationPopup = true
      }

      // Add hash handling for direct URL hash navigation
      window.addEventListener('hashchange', this.handleHashChange)
      
      // Prevent browser's default hash scroll and handle it manually
      if (window.location.hash) {
        const hash = window.location.hash.replace('#', '')
        // Temporarily remove hash to prevent browser's default scroll
        history.replaceState(null, null, ' ')
        
        // Wait for DOM to be ready, then scroll to correct position with offset
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollToHash(hash)
            // Restore hash after scrolling
            history.replaceState(null, null, `#${hash}`)
          }, 100)
        })
      }

      this.$nextTick(() => {
        this.setupIntersectionObserver()

        document.addEventListener('click', (e) => {
          const filter = document.querySelector('.filter')
          if (filter) {
            if (!filter.contains(e.target)) {
              this.showFilter = false
            }
          }
        })
      })
    },
    computed: {
      ...mapState(['menu', 'location', 'defaultMenu','order', 'channel', 'deeplinkProductNotFoundAtLocation', 'deeplinkProduct', 'deeplinkProductQuery']),
      categories() {
        let menu = this.defaultMenu
        if (this.menu) {
          menu = this.menu
        }
        return menu.categories
      },
      filteredCategories() {
        if (this.menu) {
          // If menu is set, return all categories
          return this.categories
        }
        
        // If menu is not set, filter out hidden products from all categories
        const allRemovedProducts = []
        const allNotFoundInMenu = []
        
        const filteredCats = this.categories.map(category => {
          const removedProducts = []
          const filteredProducts = category.products.filter(product => {
            const shouldHide = this.hiddenProductSKUs.includes(product.sku)
            if (shouldHide) {
              removedProducts.push({ name: product.name, sku: product.sku, category: category.name })
              allRemovedProducts.push({ name: product.name, sku: product.sku, category: category.name })
            }
            return !shouldHide
          })
          
          return {
            ...category,
            products: filteredProducts
          }
        })
        
        // Find SKUs in hiddenProductSKUs that are NOT found anywhere
        const allProducts = this.categories?.flatMap(cat => cat.products) || []
        const foundSKUs = allProducts.map(p => p.sku)
        const notFoundSKUs = this.hiddenProductSKUs.filter(sku => !foundSKUs.includes(sku))
        
        notFoundSKUs.forEach(sku => {
          allNotFoundInMenu.push(sku)
        })
        
        // Single summary log for entire menu filtering
        // console.log('MENU FILTERING SUMMARY:', {
        //   totalCategories: this.categories.length,
        //   totalProducts: this.categories.reduce((sum, cat) => sum + cat.products.length, 0),
        //   visibleProducts: filteredCats.reduce((sum, cat) => sum + cat.products.length, 0),
        //   hiddenProducts: allRemovedProducts.length,
        //   removedProducts: allRemovedProducts.map(p => `${p.name} (SKU: ${p.sku}) from ${p.category}`),
        //   notFoundInMenu: allNotFoundInMenu
        // })
        
        return filteredCats
      },
      // Products to hide by ID when menu is not set
      hiddenProductSKUs() {
        // Bo's Chicken Biscuit - ID 601557
        // Sausage Biscuit - ID 402745
        // Bo's Chicken Tenders Combo - ID 601560
        // $5 after 5pm 2pc Dinner - ID 942371
        // Salted Caramel Apple Crisp - ID 1007822
        // Bo-Berry Cookie - ID 766376
        // 8pc Family Meal - ID 942372
        // Tenders Snack - ID 935203
        // Taste the Truth 3px Tenders Snack - ID 1030147
        return [601557, 402745, 601560, 942371, 1007822, 766376, 942372, 935203, 1030147]
      },
    },
    methods: {
      closeItemNotFound() {
        this.showItemNotFound = false
        this.$store.commit('setDeeplinkProduct', null)
        this.$store.commit('setDeeplinkProductQuery', null)
        this.$store.commit('setDeeplinkProductNotFoundAtLocation', false)
      },
      slug(name) {
        return name.toLowerCase().replace(/ /g, '-').replace(/'/g, '').replace(/’/g, '').trim()
      },
      name(category) {
        return category.name.split(' - ')[0]
      },
      available(category) {
        if (category.name.split(' - ')[1]) {
          return category.name.split(' - ')[1]
        }
      },
      toggle(category) {
        const index = this.selected.indexOf(category)
        if (index !== -1) {
          this.selected.splice(index, 1)
        } else {
          this.selected.push(category)
        }
      },

      availability(item) {
        let description = ''
        if (item.availability?.description) {
          description = item.availability.description
        }
        let dayWanted = moment().format('dddd')
        if (this.order && this.order.time.wanted) {
          dayWanted = moment(this.order.time.wanted, 'YYYYMMDD HH:mm').format('dddd')
        }
        const parts = description.split(',')
        for (let i = 0; i < parts.length; i++) {
          const part = parts[i]
          if (part.includes(dayWanted)) {
            description = part.trim()
            break
          }
        }
        return description
      },
      hasAvailableItems(category) {
        if (this.order && this.order.handoff) {
          let hasAvailableItems = false
          category.products.forEach((product) => {
            const unavailablehandoffmodes = product.unavailablehandoffmodes || []
            if (!unavailablehandoffmodes.includes(this.order.handoff)) {
              hasAvailableItems = true
            }
          })

          return hasAvailableItems
        } else {
          return category.products.length > 0
        }
      },
      getImageSrc(item) {
        if (item && item.images && item.images[1]) {
          const baseUrl =
            process.env.GW_ENV === 'stage' || process.env.GW_ENV === 'prod'
              ? '//olo-images-live.imgix.net/'
              : '//olo-images-sandbox.imgix.net/';
          return baseUrl + item.images[1].filename;
        }
        return '';
      },
      goToLocations(item) {
        let currentSku = null;
        if (item && item.sku) {
          currentSku = item.sku;
          this.$store.commit('setActiveSku', currentSku);
        }
        this.$router.push('/locations');
      },
      unavailablehandoffmodes(product) {
        return product.unavailablehandoffmodes || []
      },
      toggleAll(category) {
        const name = this.slug(category.name.split(' - ')[0])
        const section = document.querySelector(`[data-category="${name}"]`)
        if (section) {
          if (this.showAll.includes(category.id)) {
            section.classList.remove('see-all')
            this.showAll = this.showAll.filter(item => item !== category.id)
          } else {
            section.classList.add('see-all')
            this.showAll.push(category.id)
          }
        }
      },
      getId(cat) {
        let index = this.filteredCategories.indexOf(cat)
        return `${cat.name.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-')}`
      },
      setupIntersectionObserver() {
        // Check if we're in a browser environment
        if (typeof window === 'undefined') {
          return
        }

        // Check if IntersectionObserver is supported
        if (!('IntersectionObserver' in window)) {
          return
        }

        const options = {
          root: null,
          threshold: 0.5 // When 50% of the element is visible
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const categoryId = entry.target.id
              // Only track if not previously observed, to avoid firing the event when the user scrolls back up
              if (!this.observedCategories.has(categoryId)) {
                const category = this.filteredCategories.find(cat => this.getId(cat) === categoryId)
                if (category) {
                  this.sendViewItemListEvent(category)
                  this.observedCategories.add(categoryId)
                }
              }
            }
          })
        }, options)

        this.$nextTick(() => {
          this.filteredCategories.forEach(cat => {
            const element = document.querySelector(`[data-category="${this.slug(cat.name.split(' - ')[0])}"]`)
            if (element) {
              observer.observe(element)
            }
          })
        })
      },
      sendViewItemListEvent(category) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'event': 'view_item_list',
          'ecommerce': {
            'affiliation': this.channel,
            'currency': 'USD',
            'item_list_id': category.id,
            'item_list_name': category.name,
            'location_name': this.location?.name,
            'location_code': this.location?.id,
            items: category.products.map((product, index) => ({
              'index': index,
              'item_id': product.id,
              'item_name': product.name,
              'price': product.cost,
            }))
          }
        })
      },
      findProductByQuery(productSlug) {
        if (!productSlug) return null
        
        // console.log('Searching for product:', productSlug)
        
        let menu = this.menu
        let product = null
        
        if (menu?.categories) {
          // console.log('Searching in current location menu...')
          product = this.searchProductInMenu(productSlug, menu)
        }
        
        if (product) {
          // console.log('Found product:', product.name)
        } else {
          // console.log('No product found for:', productSlug)
        }
        
        return product
      },
      searchProductInMenu(productSlug, menu) {
        if (!menu?.categories) return null

        // Normalize string for comparison
        const normalize = str => {
          return str
            .toLowerCase()
            .replace(/®/g, '')                  // strip symbols like ®
            .replace(/&/g, 'and')               // unify "&" → "and"
            .replace(/[^a-z0-9]+/g, '-')        // spaces/symbols → dashes
            .replace(/^-+|-+$/g, '')            // trim leading/trailing dashes
        }

        const target = normalize(productSlug)

        let bestMatch = null
        let bestScore = Infinity // lower score = better

        // Simple Levenshtein distance implementation
        const levenshtein = (a, b) => {
          const dp = Array.from({ length: a.length + 1 }, () =>
            Array(b.length + 1).fill(0)
          )

          for (let i = 0; i <= a.length; i++) dp[i][0] = i
          for (let j = 0; j <= b.length; j++) dp[0][j] = j

          for (let i = 1; i <= a.length; i++) {
            for (let j = 1; j <= b.length; j++) {
              if (a[i - 1] === b[j - 1]) {
                dp[i][j] = dp[i - 1][j - 1]
              } else {
                dp[i][j] = Math.min(
                  dp[i - 1][j] + 1,    // deletion
                  dp[i][j - 1] + 1,    // insertion
                  dp[i - 1][j - 1] + 1 // substitution
                )
              }
            }
          }

          return dp[a.length][b.length]
        }

        for (const cat of menu.categories) {
          for (const product of cat.products) {
            // Clean product name by removing time data (everything after ' - ')
            const cleanName = product.name.split(' - ')[0].trim()
            const productSlug = normalize(cleanName)
            
            // console.log('Product:', product.name, 'Cleaned:', cleanName, 'Normalized:', productSlug, 'Target:', target)

            // Exact match, return immediately
            if (productSlug === target) {
              // console.log('Exact match found!')
              return product
            }

            // Otherwise, calculate similarity score
            const score = levenshtein(productSlug, target)
            if (score < bestScore) {
              bestScore = score
              bestMatch = product
            }
          }
        }

        // If no exact match, only return fuzzy match if score is reasonable (threshold of 2)
        // This prevents false positives for completely unrelated products
        if (bestMatch && bestScore <= 2) {
          // console.log('Fuzzy match found with score:', bestScore, 'for product:', bestMatch.name)
          return bestMatch
        }
        
        // console.log('No good match found. Best score was:', bestScore, 'for product:', bestMatch?.name || 'none')
        return null
      },
      handleHashChange() {
        if (window.location.hash) {
          const hash = window.location.hash.replace('#', '')
          // Prevent browser's default scroll by temporarily removing hash
          history.replaceState(null, null, ' ')
          
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollToHash(hash)
              // Restore hash after scrolling
              history.replaceState(null, null, `#${hash}`)
            }, 100)
          })
        }
      },
      scrollToHash(hash) {
        // Try to find element by ID first (since that's what the hash targets)
        let section = document.getElementById(hash)
        
        // If not found by ID, try data-category attribute (using slug format)
        if (!section) {
          // Try matching with slug format
          const allSections = document.querySelectorAll('[data-category]')
          for (let i = 0; i < allSections.length; i++) {
            const catName = allSections[i].getAttribute('data-category')
            if (catName === hash) {
              section = allSections[i]
              break
            }
          }
        }
        
        if (section) {
          const header = document.querySelector('header')
          const headerHeight = header ? header.clientHeight : 0
          const navHeight = this.$mq === 'sm' || this.$mq === 'md' ? 48 : 65
          let position = section.offsetTop - headerHeight - navHeight
          
          // Scroll to top if first category is selected (matching MenuNav behavior)
          if (this.filteredCategories.length > 0) {
            const firstCategoryName = this.filteredCategories[0].name.split(' - ')[0]
            const firstCategorySlug = this.slug(firstCategoryName)
            if (hash === firstCategorySlug || hash === this.getId(this.filteredCategories[0])) {
              position = 0
            }
          }
          
          window.scrollTo({ 
            top: Math.max(0, position), 
            behavior: 'smooth' 
          })
          
          // Dispatch scroll event to update active state in MenuNav if present
          window.dispatchEvent(new Event('scroll'))
        }
      }
    },
    destroyed() {
      window.removeEventListener('hashchange', this.handleHashChange)
    },
    watch: {
      filteredCategories: {
        handler() {
          this.$nextTick(this.setupIntersectionObserver)
        },
        immediate: true,
      },
    }
  }
